// extracted by mini-css-extract-plugin
export default {"container":"teamcard_container__I5D5R","typography":"teamcard_typography__nFP26","name":"teamcard_name__oR1no","role":"teamcard_role__0Xngx","img":"teamcard_img__ssjex"};